import React, { useState, useEffect } from "react";
import axios from "axios";
import { getBaseUrl } from "../utils";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';

const QuizForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [answers, setAnswers] = useState({});
  const [timeLeft, setTimeLeft] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [longDescription, setLongDescription] = useState("");
  const [showDescription, setShowDescription] = useState(true);
  const [hasStarted, setHasStarted] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showReview, setShowReview] = useState(false);
  const [cameFromReview, setCameFromReview] = useState(false);

  const baseUrl = getBaseUrl();
  const token = localStorage.getItem("userToken");
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const testId = params.get("testId");

  useEffect(() => {
    const storedTestId = localStorage.getItem("testId");
    const storedAnswers = JSON.parse(localStorage.getItem("examAnswers"));

    if (storedTestId === testId && storedAnswers) {
      setAnswers(storedAnswers);
    }
  }, [testId]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "Are you sure you want to leave?";
    };

    const handlePopState = () => {
      window.history.pushState(null, document.title, window.location.href);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    const fetchQuestions = async () => {
      if (!testId) {
        console.error("testId not found in URL");
        return;
      }

      try {
        const response = await axios.get(
          `${baseUrl}user_api/testQuestions?testId=${testId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { results } = response.data;
        setQuestions(results.questions);
        setTimeLeft(results.duration * 60);
        setLongDescription(results.longDescription);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching quiz data:", error);
        setLoading(false);
      }
    };

    fetchQuestions();
  }, [baseUrl, token, testId]);

  useEffect(() => {
    if (!hasStarted || timeLeft === 0 || loading) return;

    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          alert("Oops! Times Up… A test has been submitted")
          submitQuiz();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft, loading, hasStarted]);

  const handleAnswer = (questionId, option, subjectId) => {
    if (isSubmitting) return;

    const updatedAnswers = {
      ...answers,
      [questionId]: { studentOption: option, subjectId },
    };
    setAnswers(updatedAnswers);
    localStorage.setItem("examAnswers", JSON.stringify(updatedAnswers));
    localStorage.setItem("testId", testId);
  };

  const startTest = () => {
    setShowDescription(false);
    setHasStarted(true);
  };

  const nextStep = () => {
    if (currentStep < questions.length) {
      setCurrentStep(currentStep + 1);
    } else {
      setShowReview(true);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  const confirmAndSubmit = () => {
    if (window.confirm("Are you sure you want to submit your exam?")) {

      alert("Test has been submitted successfully")
      submitQuiz();
    }
  };
  const goBackToQuestions = () => {
    setShowReview(false);
    setCurrentStep(questions.length);
  };


  const submitQuiz = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const ans = Object.keys(answers).map((questionId) => ({
      questionId,
      subjectId: answers[questionId].subjectId,
      studentOption: answers[questionId].studentOption,
    }));

    const payload = { testId, ans };
    const loadingToast = toast.loading("Processing... Please wait");

    try {
      await axios.post(`${baseUrl}user_api/userTestSubmit`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowSuccessModal(true);
      localStorage.removeItem("examAnswers");
      localStorage.removeItem("testId");
      toast.dismiss(loadingToast);
      // setTimeout(() => navigate("/dashboard/examList"), 3000);
      setTimeout(() => {
        navigate("/dashboard/examList", {
          state: { activeTab: "Given Tests" }
        });
      }, 3000);
    } catch (error) {
      toast.dismiss(loadingToast);
      setShowSuccessModal(true);
      localStorage.removeItem("examAnswers");
      localStorage.removeItem("testId");
      setTimeout(() => navigate("/dashboard/examList"), 3000);
      console.error("Error submitting quiz:", error);
      alert("Failed to submit the quiz.");
    }
  };

  const goToQuestion = (index) => {
    setShowReview(false);
    setCurrentStep(index + 1);
    setCameFromReview(true);
  };

  console.log('alsdflskdjflkjasdlfjlsadjfflsakfjalskjflkasjlfj');
  return (
    <>
      <ToastContainer />

      <div className="md:flex md:flex-1" onContextMenu={(e) => e.preventDefault()}>
        {showReview ? (
          <div className="bg-white shadow-lg rounded-2xl w-full max-w-3xl p-6">
            <h2 className="text-xl font-bold mb-4">Review Your Answers</h2>

            {questions.map((q, index) => (
              <div key={q._id} className="mb-4">
                <div className="font-medium">Q{index + 1}: {q.name.replace(/\\n/g, "\n").split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}</div>
                {/* <div className="text-gray-700">Selected: {answers[q._id]?.studentOption || "Not Answered"}</div> */}
                <div className="text-gray-700">Selected: {answers[q._id] ? answers[q._id].studentOption.replace(/\\n/g, "\n").split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                )) : "Not Answered"}</div>

                <button
                  onClick={() => goToQuestion(index)}
                  className="mt-2 py-1 px-4 bg-gray-500 text-white rounded-lg"
                >
                  Go to Question
                </button>
              </div>
            ))}
            <div className="flex space-x-4 mt-6">
              <button onClick={goBackToQuestions} className="w-full py-2 bg-gray-500 text-white rounded-lg mt-4">Back</button>
              {/* <button onClick={confirmAndSubmit} className="w-full py-2 bg-black text-white rounded-lg mt-4">Submit Exam</button> */}
              <button
  onClick={confirmAndSubmit}
  disabled={isSubmitting}
  className={`w-full py-2 rounded-lg mt-4 ${
    isSubmitting
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-black text-white"
  }`}
>
  {isSubmitting ? "Submitting..." : "Submit Exam"}
</button>
            </div>
          </div>
        ) : (
          <div className="flex flex-1" onContextMenu={(e) => e.preventDefault()}>
            {showDescription ? (
              <div className="bg-white shadow-lg rounded-2xl w-full max-w-4xl p-6">
                <div className="text-xl font-bold mb-4">Test Instructions</div>
                <div dangerouslySetInnerHTML={{ __html: longDescription }} className="text-gray-700 mb-6" />
                <button onClick={startTest} className="w-full py-2 bg-black text-white rounded-lg mt-20">
                  Start Test
                </button>
              </div>
            ) : (
              <div className="flex-1 flex justify-center items-center">
                <div className="bg-white shadow-lg rounded-2xl w-full max-w-4xl p-6">
                  <div className="text-xl font-bold mb-4">Q. No. {currentStep}</div>
                  {questions[currentStep - 1]?.nameType === "File" ? (
                    <img src={questions[currentStep - 1]?.name} alt="Question" className="mb-6" />
                  ) : (
                    //<div className="text-gray-700 mb-6 no-select" onContextMenu={(e) => e.preventDefault()}>{questions[currentStep - 1]?.name}</div>
                    // <div
                    //   className="text-gray-700 mb-6 no-select"
                    //  // onContextMenu={(e) => e.preventDefault()}
                    //   dangerouslySetInnerHTML={{
                    //     __html: questions[currentStep - 1]?.name,
                    //   }}
                    // ></div>
                    <div className="text-gray-700 mb-6 no-select" onContextMenu={(e) => e.preventDefault()} >
                      {questions[currentStep - 1]?.name.replace(/\\n/g, "\n").split("\n").map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}
                    </div>
                  )}
                  <div className="grid grid-cols-2 gap-4">
                    {questions[currentStep - 1]?.options.map((option) => (
                      <button
                        key={option}
                        onClick={() =>
                          handleAnswer(
                            questions[currentStep - 1]._id,
                            option,
                            questions[currentStep - 1].subjectId
                          )
                        }
                        className={`w-full py-2 px-4 text-left rounded-lg border ${answers[questions[currentStep - 1]._id]?.studentOption === option
                          ? "bg-black text-white"
                          : "bg-gray-50 text-gray-700"
                          }`}
                        disabled={isSubmitting}
                      >
                        <span>
                          {option.replace(/\\n/g, "\n").split("\n").map((line, index) => (
                            <div key={index}>{line}</div>
                          ))}
                        </span>
                        {/* {option === questions[currentStep - 1].correctOption && (
                        <span className="text-blue-500 font-bold">•</span>
                      )} */}
                      </button>
                    ))}
                  </div>
                  <div className="flex space-x-4 mt-20">
                    {currentStep !== 1 && (
                      <button
                        onClick={prevStep}
                        disabled={currentStep === 1 || isSubmitting}
                        className="w-full py-2 bg-gray-300 text-gray-700 rounded-lg disabled:opacity-50"
                      >
                        Previous
                      </button>
                    )}
                    <button onClick={nextStep} disabled={isSubmitting} className="w-full py-2 bg-black text-white rounded-lg">
                      {currentStep === questions.length ? "Submit" : "Next"}
                    </button>
                    {cameFromReview && (
                      <button
                        onClick={() => {
                          setCameFromReview(false);
                          setShowReview(true);
                        }}
                        className="w-full py-2 bg-black text-white rounded-lg"
                      >
                        Go to Review
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showSuccessModal && (
              <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
                <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                  <h2 className="text-lg font-bold mb-4">Exam Submitted Successfully!</h2>
                  <p className="text-gray-700">Redirecting to the Test page...</p>
                </div>
              </div>
            )}
          </div>
        )}
        {!showDescription && (
          <div className="bg-white shadow-lg rounded-xl md:w-60 p-4 md:m-8 md:mt-0 mt-6 overflow-y-auto">
            <div className="flex justify-between mb-4">
              <div className="text-sm font-medium">Total Questions</div>
              <div className="text-sm">{questions.length}</div>
            </div>
            <div className="flex justify-between mb-4">
              <div className="text-sm font-medium">Questions Remaining</div>
              <div className="text-sm">{questions.length - currentStep}</div>
            </div>
            <div className="flex justify-between">
              <div className="text-sm font-medium">Time Left</div>
              <div className="text-sm">{`${Math.floor(timeLeft / 60)
                .toString()
                .padStart(2, "0")}:${(timeLeft % 60).toString().padStart(2, "0")}`}</div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default QuizForm;